var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationsPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3852_14924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6073 16.3353L15.5473 11.2032C15.2883 11.0154 14.9443 10.9871 14.6603 11.1331C14.3741 11.2779 14.1953 11.5721 14.1953 11.89V22.1508C14.1953 22.4721 14.3741 22.7651 14.6603 22.9099C14.7814 22.971 14.9138 23.0016 15.0473 23.0016C15.2215 23.0016 15.398 22.9461 15.5473 22.8364L22.6073 17.7088C22.8302 17.5448 22.9603 17.2914 22.9603 17.0221C22.9615 16.7483 22.828 16.496 22.6073 16.3353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0006 0.00231934C7.60986 0.00231934 0 7.61218 0 17.0029C0 26.3902 7.60986 33.9978 17.0006 33.9978C26.389 33.9978 34 26.3891 34 17.0029C34.0011 7.61218 26.389 0.00231934 17.0006 0.00231934ZM17.0006 31.1613C9.18026 31.1613 2.83984 24.8243 2.83984 17.0029C2.83984 9.18484 9.18026 2.8399 17.0006 2.8399C24.8197 2.8399 31.159 9.18371 31.159 17.0029C31.1602 24.8243 24.8197 31.1613 17.0006 31.1613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3852_14924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsPlay);
export default __webpack_public_path__ + "static/media/conversations-play.624cbfee9dee5666d82c5662630110fb.svg";
export { ForwardRef as ReactComponent };